import { useEffect, useRef } from "react";
import { recentOrigin } from "../lib/telemetry/recentControl.js";
import { emitPanelToggle } from "../lib/telemetry/uiIntents.js";

/**
 * `panel.toggle` (P2 design §4.6) for the side panels, at their open-state transitions, when a
 * control the user just pressed toggles panels (a rail section, the collapse control, the
 * question title, a drawer tab, the indices bar). A transition no press caused (the tour, a
 * chat command, boot) is no `panel.toggle`. One press that switches the rail from one section
 * to another counts once, as the panel it opened.
 *
 * @param {Record<string, boolean>} panels open state by `panel` enum value
 */
export function usePanelToggleIntents(panels) {
  const prevRef = useRef(null);
  const key = Object.entries(panels)
    .map(([k, v]) => `${k}:${v ? 1 : 0}`)
    .join(",");
  useEffect(() => {
    const prev = prevRef.current;
    prevRef.current = { ...panels };
    if (!prev) return;
    const changed = Object.keys(panels).filter((k) => Boolean(prev[k]) !== Boolean(panels[k]));
    if (changed.length === 0) return;
    const origin = recentOrigin("panel.toggle");
    if (!origin) return;
    const opened = changed.filter((k) => panels[k]);
    for (const k of opened.length > 0 ? opened : changed) {
      emitPanelToggle(k, Boolean(panels[k]), { origin });
    }
    // `key` is the panels' open state; the object itself is new every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
}
